<template>
  <v-container fluid grid-list-md>
    <v-card class="mx-auto" >
        <v-toolbar color="primary" dark>
          <v-icon left>receipt</v-icon>
          <v-toolbar-title>
            <span v-if="hasInvoiceData">
              Cobrança #{{invoice.id}}
              <span v-if="invoice.name" class="subtitle-1 ml-2">- {{invoice.name}}</span>
            </span>
            <span v-else>
              Carregando...
            </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="goBack">
            <v-icon>arrow_back</v-icon>
          </v-btn>
          <!--v-btn icon>
            <v-icon>print</v-icon>
          </v-btn-->
        </v-toolbar>
      <invoice-content />
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Invoice',
  computed: {
    ...mapGetters({
      invoice: 'invoices/invoice',
      isLoading: 'invoices/loadingData',
    }),
    hasInvoiceData() {
      return this.invoice && Object.keys(this.invoice).length > 0;
    }
  },
  created() {
    this.$store.dispatch('invoices/get', this.$route.params.id);
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  },
  components: {
    InvoiceContent: () => import('@/components/invoices/InvoiceContent.vue'),
  },
};
</script>
